import { Box } from '@mui/material';
import React, { useEffect, useRef } from 'react';
import { Navigate, useOutletContext } from 'react-router-dom';
import BasicInfoForm from '../ui/BaseInfoForm';
import TypeWork from '../ui/TypeWork';
import Complete from '../../ui/Complete';
import BackClickBottomSheet from '../../ui/BackClickBottomSheet';
import { CommonActions } from '../../../../Reducer/CommonReducer';
import { useDispatch, useSelector } from 'react-redux';
import { BottomSheetActions } from '../../../../Reducer/BottomSheetReducer';
import SelectDepHeadIdBottomSheet from '../ui/SelectDepHeadIdBottomSheet';
import WriteCheckListCommon from '../ui/WriteCheckListCommon';
import { NavBarInfoActions } from '../../../../Reducer/NavBarInfoReducer';

export default function M_PER_CUSTOM_01(props) {
  const containerRef = useRef(null);
  const dispatch = useDispatch();
  const bottomSheetState = useSelector((state) => state.bottomSheet);

  useEffect(() => {
    dispatch(NavBarInfoActions.setType('titleBar'));
    dispatch(NavBarInfoActions.setTitleName('작업 허가서'));
    dispatch(CommonActions.setActiveStep(1));
  }, []);
  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTo(0, 0);
    }
  }, [props.activeStep]);

  const steps = {
    1: (
      <BasicInfoForm
        variant="CUSTOM"
        errors={props.errors}
        handleChange={props.handleChange}
        rowData2={props.rowData2}
        ValidateAll={props.ValidateAll}
      />
    ),
    2: <TypeWork Search2={props.Search2} />,
    3: <WriteCheckListCommon title="위험사항" codeListKey="risks" />,
    4: <WriteCheckListCommon title="보호구" codeListKey="equips" />,
    5: (
      <WriteCheckListCommon
        title="준비사항"
        codeListKey="preparations"
        onNext={() => {
          dispatch(
            BottomSheetActions.SetBottomSheetState({
              bottom: true,
              type: 'selectDepHeadId',
            })
          );
        }}
      />
    ),

    6: <Complete />,
  };

  return (
    <Box
      ref={containerRef}
      sx={{
        px: 2,
        display: 'flex',
        flexDirection: 'column',
        fontSize: '18px',
        fontWeight: 'bold',
        height: '100%',
        overflowY: 'auto',
      }}
    >
      {steps[props.activeStep] ? (
        steps[props.activeStep]
      ) : (
        <Navigate to="/M_Permit" replace />
      )}

      {bottomSheetState.bottom && bottomSheetState.type === 'backClick' && (
        <BackClickBottomSheet
          open={true}
          SearchLogic1={props.SearchLogic1}
          route={props.id ? `/M_Permit/detail/${props.id}` : '/M_Permit'}
        />
      )}

      {bottomSheetState.bottom &&
        bottomSheetState.type === 'selectDepHeadId' && (
          <SelectDepHeadIdBottomSheet Save1={props.Save1} />
        )}
    </Box>
  );
}
